import { storeCard, deleteCard } from "./../../api/services/userService.js";
import { mapGetters } from "vuex";
export default {
  filters: {
    cardName: function(value) {
      if (!value) return "";
      let index = value.indexOf("card");
      if (index === -1) {
        return value;
      } else {
        return value.substring(0, index);
      }
    },
  },

  computed: {
    ...mapGetters(["user", "currentStoreDoc"]),
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
    closeConfirm() {
      this.showConfirm = false;
    },
    selectCard(val) {
      this.selectedCard = val;
      this.showConfirm = true;
      this.cardError = "";
    },
    addCard() {
      var that = this;
      let cms = [];
      let cardInfo = this.$refs.cardInfo.validate();
      cms.push(cardInfo);

      let current = this.$validator.validateAll();
      cms.push(current);
      Promise.all(cms)
        .then((values) => {
          if (values.every((v) => v)) {
            if (this.dbuser) {
              this.loading = true;
              this.error = "";
              let exDate = this.editModel.ExpireDate.split("/");
              
              let data = {
                holder:
                  this.editModel.CardHolder ||
                  this.dbuser.FirstName + " " + this.dbuser.LastName,
                number: this.editModel.CardNumber,
                cvc: this.editModel.CVV,
                expMonth: exDate[0],
                expYear: `20${exDate[1]}`,
              };
              
              storeCard(
                this.user.id,
                data,
                this.currentStoreDoc.HQCompanyID,
                function(error) {
                  that.error = error;
                  that.loading = false;
                }
              )
                .then((res) => {
                  this.loading = false;
                  if (res.data.Success === true) {
                    this.$refs.addModal.hideModal();
                  } else {
                    this.error = res.data.Status.Message;
                  }
                })
                .catch(() => {
                  that.error = "Network Error ...!";
                  that.loading = false;
                });
            }
          } else {
            that.$el.querySelector("[aria-invalid=true]").focus();
          }
        })
        .catch((e) => {
          that.error = e.message;
          that.loading = false;
        });
    },
    deleteCard() {
      this.deleting = true;
      this.cardError = "";
      deleteCard(this.user.id, this.selectedCard, this.currentStoreDoc.HQCompanyID)
        .then((res) => {
          this.deleting = false;
          if (res.data.Success === true) {
            this.$refs.deleteConfirm.hideModal();
          } else {
            this.cardError = res.data.Status.Message;
          }
        })
        .catch(() => {
          this.cardError = "Network Error ...!";
          this.deleting = false;
        });
    },
    fncShowModal() {
      this.showModal = true;
      this.editModel = {};
    },
  },
};
